import {
  ConfirmPracticeContractAgreementArgs,
  DeletePracticeContractArgs,
  SendPracticeContractArgs,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from './functions'

export const sendPracticeContracts = httpsCallable<SendPracticeContractArgs>(
  functions,
  'sendPracticeContracts',
)

export const confirmPracticeContractAgreement = httpsCallable<ConfirmPracticeContractAgreementArgs>(
  functions,
  'confirmPracticeContractAgreement',
)

export const deletePracticeContract = httpsCallable<DeletePracticeContractArgs>(
  functions,
  'deletePracticeContract',
)

export const deletePracticeContractTemplate = httpsCallable<{ templateId: string }>(
  functions,
  'deletePracticeContractTemplate',
)
